import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import SectionTitle from "../../components/SectionTitle";
import { SERVER_URL } from "../../api/url";
import axios from "axios";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router";

const Event = () => {
  const [data, setData] = useState([]);
 const navigate = useNavigate();
  useEffect(() => {
    fetchInfo();
  }, []);

  const fetchInfo = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/event?isDone=false`);
      const fetchedData = response.data?.data || [];
      setData(fetchedData);
    } catch (err) {
      console.error(err.response);
    }
  };

  const eventSetting = {
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  };

  return (
   <>
      {
        data?.length > 0 && (
           <div className="react-upcoming__event blog__area">
          <div className="mx-lg-5">
        <SectionTitle Title="Join Our Events & Programs" />
        <div className="client-slider wow animate__fadeInUp" data-wow-duration="0.3s">
          <Slider {...eventSetting}>
            {data.map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="event-card w-full mb-3">
                  <img
                    crossOrigin="anonymous"
                    src={`https://back.yourfrenchteachers.com/${item.coverDesktop}`}
                    alt={item.title || "Event cover"}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>

                {/* Only show button if there is a link */}
                {item.name? (
                  <a
                    href={item.name} target="_blank"
                    rel="noopener noreferrer"
                    style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"10px"}}
                    className=" bg-gray text-primary px-4 py-2 rounded hover:primary transition-colors"
                  >
                   More Detail Event  <FaArrowRight className="ml-2" />
                  </a>
                ) : null}
              </div>
            ))}
          </Slider>
        </div>
      </div>
       </div>
        )
      }
    </>
  );
};

export default Event;
